import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface WelcomeModal {
  id: number;
  title: string;
  description?: string;
  image_url?: string;
  is_active: boolean;
}

const API_BASE = import.meta.env.VITE_API_URL || 'http://localhost:8000/api';

export default function WelcomeModal() {
  const [modals, setModals] = useState<WelcomeModal[]>([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const fetchActiveModals = async () => {
      try {
        if (location.pathname !== '/') {
          return;
        }

        const response = await fetch(`${API_BASE}/welcome-modals/public.php`);
        
        if (response.ok) {
          const data = await response.json();
          const activeModals = data.filter((m: WelcomeModal) => m.image_url);
          if (activeModals.length > 0) {
            setModals(activeModals);
            setShowModal(true);
          }
        }
      } catch (error) {
        console.error('Error fetching welcome modals:', error);
      }
    };

    fetchActiveModals();
  }, [location.pathname]);

  useEffect(() => {
    if (modals.length <= 1) return;

    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % modals.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [modals.length]);

  if (!showModal || modals.length === 0) {
    return null;
  }

  const currentModal = modals[currentIndex];

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="relative">
        <button
          onClick={() => setShowModal(false)}
          className="absolute top-4 right-4 z-10 w-8 h-8 flex items-center justify-center bg-black bg-opacity-50 hover:bg-opacity-70 rounded-full transition-all"
        >
          <i className="ri-close-line text-white text-xl"></i>
        </button>
        
        <img
          src={currentModal.image_url}
          alt={currentModal.title}
          className="max-w-[90vw] max-h-[90vh] object-contain rounded-lg"
        />

        {modals.length > 1 && (
          <>
            <button
              onClick={() => setCurrentIndex((prev) => (prev - 1 + modals.length) % modals.length)}
              className="absolute left-4 top-1/2 transform -translate-y-1/2 w-10 h-10 flex items-center justify-center bg-black bg-opacity-50 hover:bg-opacity-70 rounded-full transition-all"
            >
              <i className="ri-arrow-left-s-line text-white text-2xl"></i>
            </button>
            
            <button
              onClick={() => setCurrentIndex((prev) => (prev + 1) % modals.length)}
              className="absolute right-4 top-1/2 transform -translate-y-1/2 w-10 h-10 flex items-center justify-center bg-black bg-opacity-50 hover:bg-opacity-70 rounded-full transition-all"
            >
              <i className="ri-arrow-right-s-line text-white text-2xl"></i>
            </button>

            <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex gap-2">
              {modals.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentIndex(index)}
                  className={`w-2 h-2 rounded-full transition-all ${
                    index === currentIndex ? 'bg-white w-6' : 'bg-white bg-opacity-50'
                  }`}
                />
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
